import { Slider } from "@mui/material";

export { Slider };
